import { render, staticRenderFns } from "./innovateproject.vue?vue&type=template&id=7ca27c00&scoped=true&"
import script from "./innovateproject.vue?vue&type=script&lang=js&"
export * from "./innovateproject.vue?vue&type=script&lang=js&"
import style0 from "./innovateproject.vue?vue&type=style&index=0&id=7ca27c00&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca27c00",
  null
  
)

export default component.exports